import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
      <Seo title="Page Not Found" description="The page you were looking for doesn't exist." />
      <p className="overline mb-4">404</p>
      <h1 className="font-display text-5xl md:text-7xl tracking-tighter text-zinc-950">Page not found</h1>
      <p className="mt-4 text-zinc-600 max-w-md">The page you’re looking for isn’t here. Let’s get you back on track.</p>
      <Link
        to="/"
        className="mt-8 bg-orange-600 hover:bg-orange-700 text-white px-7 py-4 text-sm font-bold uppercase tracking-wider transition"
        data-testid="not-found-home-link"
      >
        Back home
      </Link>
    </div>
  );
}
